export default __webpack_public_path__ + "images/edificioDefault.59d1f38fa5c83e69c4622dc9a1076a06.jpg";